import React, {useEffect, useState} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Divider from '@material-ui/core/Divider';

import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
//import { showProfileDriverEmailModal, hideProfileDriverEmailModal } from '../../store/profile/action';



const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,       
  },
  btnConfirm: {
    borderRadius:10,
    backgroundColor:"#20419a",
    color:"white"
  },
  btnRow: {
    textAlign: 'right',
    marginTop: 20,
  },
  btnRows: {
   fontSize:'20px'
  },
}));



export default function AlertModalForm(props) {
  const classes = useStyles();

  const { CloseAlertModal,data} = props;
  const [alertData, setAlertData] = useState()
  
  useEffect(() => {    
    setAlertData(data)
  }, [])
  
  return(
      <>
        <List className={classes.root}>
          <ListItem>
          <div className={classes.btnRows} >
            <p style={{margin:0,fontSize:17}}> {alertData}</p>
            </div>
          </ListItem>
          <Grid container spacing={3}>
            <Grid item xs={12} >             
              <Button style={{float:"right"}} onClick={CloseAlertModal} variant="contained" type={'submit'} color={"primary"}>
                Close
              </Button>
            </Grid>
          </Grid> 
        </List>     
      </>
    );
  
}





